// Stacking levels shared across screens, so layers that must cover one another
// are ordered in one place.

// The lesson header's right-hand controls (tempo, accuracy) on a phone.
export const LESSON_MOBILE_HEADER_CONTROLS_Z_INDEX = 3100;

// MUS-607: the lesson's tutorial video player opens over the lesson header.
// Below the header's controls, the player's close button sat under them on a
// phone in landscape and could not be tapped.
export const TUTORIAL_VIDEO_Z_INDEX = LESSON_MOBILE_HEADER_CONTROLS_Z_INDEX + 100;

// MUS-651: the "connect your keyboard" prompt opens over the tutorial video, so a
// keyboard that drops while the video plays is asked for on top, where the player
// sees it. Its backdrop, its panel, then its close and back buttons.
export const MIDI_PROMPT_BACKDROP_Z_INDEX = TUTORIAL_VIDEO_Z_INDEX + 10;
export const MIDI_PROMPT_Z_INDEX = MIDI_PROMPT_BACKDROP_Z_INDEX + 1;
export const MIDI_PROMPT_CONTROLS_Z_INDEX = MIDI_PROMPT_BACKDROP_Z_INDEX + 2;

// The "What do you play on?" picker opened from a play surface's menu: over the
// menu, the lesson header and the tutorial video, below the keyboard prompt that
// choosing "A MIDI keyboard" can bring up.
export const PLAY_INPUT_DIALOG_Z_INDEX = MIDI_PROMPT_BACKDROP_Z_INDEX - 5;

// "Keyboard connected. Use it?": asked over anything on screen when a keyboard
// connects while the account says the player has no MIDI keyboard.
export const KEYBOARD_CONNECTED_PROMPT_Z_INDEX = MIDI_PROMPT_CONTROLS_Z_INDEX + 1;

// The top of the whole app, from the top down: the offline message, the
// device-compatibility blocker, an enforced app update, then the paywall.
// Nothing else may reach these levels: StackingLevels.order.spec.ts finds the
// z-index set in each form the app uses (sx, style objects and the theme, CSS,
// JSX props, run-time assignments and setProperty), evaluates every value
// (constants, sums, ternaries, theme levels), fails on one it cannot evaluate,
// and allows a level at or above the paywall only if it is one of these, set in
// the file that draws that layer.

// The offline message covers everything in the app.
export const OFFLINE_BACKDROP_Z_INDEX = 20000;
export const OFFLINE_MESSAGE_Z_INDEX = OFFLINE_BACKDROP_Z_INDEX + 1;

// The "use the app" / "use Chrome or Edge" blocker on browsers the app does not
// run in. Above the paywall: there is nothing to subscribe to on this browser.
export const DEVICE_BLOCKER_Z_INDEX = OFFLINE_BACKDROP_Z_INDEX - 10;

// MUS-651: an announcement that blocks the app until it is updated ("Update
// App"). Above the paywall: an out-of-date build has to be updated before
// anything can be bought or played. Its dialog then holds the focus and hides
// the page below it from screen readers, the paywall included.
export const FORCED_UPDATE_Z_INDEX = DEVICE_BLOCKER_Z_INDEX - 5;

// MUS-651: the paywall, and the other account dialogs drawn the same way
// (billing, plan confirmation, pending deletion), cover everything in a lesson
// and around it: the lesson header, the tutorial video, the keyboard prompt,
// the tier wrap-up and its select menus, the app tour and the tutorial's phone
// header. The paywall opens no popover of its own; the store sheets and
// Stripe's own windows are drawn by the system or by Stripe above the page.
export const PAYWALL_BACKDROP_Z_INDEX = DEVICE_BLOCKER_Z_INDEX - 10;
export const PAYWALL_Z_INDEX = PAYWALL_BACKDROP_Z_INDEX + 1;
